import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles, typographyStyles} from '../../utils/styles';

const StyledBudgetsActivePageContainer = styled.div`
  padding: 24px;
`;

const StyledBudgetsActivePageContent = styled(Space)`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};

  border-radius: 4px;
  padding: 24px;
  width: 100%;

  .amount {
    color: ${props => props.theme.colors.neutral_10};

    &.negative {
      color: ${props => props.theme.colors.functional_danger};
    }
  }

  .grouped-row {
    color: ${props => props.theme.colors.neutral_10};
  }

  .expand-icon {
    transition: 0.2s transform;
    &:hover {
      cursor: pointer;
    }
    &.expanded {
      transform: rotate(180deg);
    }
  }

  .ant-table-row-expand-icon-cell {
    span {
      display: flex;
    }
  }
`;

const StyledBudgetsActivePageTitle = styled.div`
  color: ${props => props.theme.colors.neutral_10};
  margin-bottom: 24px;

  h4, h5 {
    display: inline-block;
    margin: 0;
    padding: 0;
  }

  h4 {
    ${typographyStyles.heading.h4};
  }

  h5 {
    ${typographyStyles.heading.h5};
    margin-left: 8px;
  }

  > * {
    margin-left: 8px;
  }
`;

export {
  StyledBudgetsActivePageContainer,
  StyledBudgetsActivePageContent,
  StyledBudgetsActivePageTitle
}
